import { IProperty } from '../../../utils';

/**
 * Sorteert de kinderen van een multi value veld op de volgorde die de gebruiker
 * in het bewerkingspaneel instelt (de pijltjes ↑/↓ schrijven naar
 * `weight_for_execution_list`). Bij een gelijk gewicht — bijvoorbeeld oudere
 * records die nog op de default 0 staan — valt de sortering terug op `id`,
 * zodat de volgorde deterministisch blijft in plaats van mee te schuiven met
 * wat de database toevallig teruggeeft.
 */
export const compareChildrenForExecutionList = (
  a: IProperty,
  b: IProperty,
): number => {
  const weightA = a.weight_for_execution_list || 0;
  const weightB = b.weight_for_execution_list || 0;

  if (weightA !== weightB) return weightA - weightB;

  return (a.id || 0) - (b.id || 0);
};

export const sortChildrenForExecutionList = (
  children: IProperty[],
): IProperty[] => [...(children || [])].sort(compareChildrenForExecutionList);

export default sortChildrenForExecutionList;
